<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import { add, getAirport, getDetails, update, del } from "@/api/system/airport";

import cTable from "@/base/common/index";
export default {
  name: "airport",

  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getAirport,
        getDetails,
        del,
        add,
        update
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airport_name: [
                {
                  required: true,
                  message: "Name cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 55,
                  message: "Please enter maximum 55",
                  trigger: "blur"
                }
              ],
              airport_code: [
                {
                  required: true,
                  message: "Code cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 15,
                  message: "Please enter maximum 15",
                  trigger: "blur"
                }
              ],
              en_name: [
                {
                  required: true,
                  message: "en_name cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 55,
                  message: "Please enter maximum 55",
                  trigger: "blur"
                }
              ],
              country: [
                {
                  required: true,
                  message: "country cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 55,
                  message: "Please enter maximum 55",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { airport_name: 24 },
            { airport_code: 24 },
            { en_name: 24 },
            { country: 24 }
          ],
          fields: [
            {
              name: () => this.$t("airport_name"),
              key: "airport_name",
              component: "Input",
              // bind: {
              //   placeholder: "Enter name"
              // },
              placeholder() {
                return this.$t("enter") + this.$t("airport_name");
              }
            },
            {
              name: () =>
                this.$t("airport_t") +
                this.$t("English") +
                this.$t("invoiceName"),
              key: "en_name",
              component: "Input",
              // bind: {
              //   placeholder: "Enter code"
              // },
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("airport_t") +
                  this.$t("English") +
                  this.$t("invoiceName")
                );
              }
            },
            {
              name: () => this.$t("airport_code"),
              key: "airport_code",
              component: "Input",
              // bind: {
              //   placeholder: "Enter code"
              // },
              placeholder() {
                return this.$t("enter") + this.$t("airport_name");
              }
            },
            {
              name: () => this.$t("ownerCountry"),
              key: "country",
              component: "Input",
              // bind: {
              //   placeholder: "Enter code"
              // },
              placeholder() {
                return this.$t("enter") + this.$t("ownerCountry");
              }
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
          // {
          //   key: "ClientId",
          //   type: "select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" }
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 158
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        // {
        //   name: "序号",
        //   type: "seq",
        //   align: "center",
        //   width: 50
        // },
        {
          name: () => this.$t("airport_name"),
          key: "airport_name",
          align: "center"
        },
        {
          name: () =>
            this.$t("enter") +
            this.$t("airport_t") +
            this.$t("English") +
            this.$t("invoiceName"),
          key: "en_name",
          align: "center"
        },
        {
          name: () => this.$t("airport_code"),
          key: "airport_code",
          align: "center"
        },
        {
          name: () => this.$t("ownerCountry"),
          key: "country",
          align: "center"
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 159
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 160

              // bind: {
              //   type: "error"
              // }
            }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
